import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
} from '@mui/material';
import { TypeAnimation } from 'react-type-animation';
import Navbar from './components/NavBar';
import ArrayMaker from './components/ArrayMaker';
import CompareTool from './components/CompareTool';
import JsonMaker from './components/JsonMaker';
import XmlTool from './components/XmlTool';
import { createTheme, ThemeProvider } from '@mui/material/styles';


// Define a custom Material-UI theme for consistent styling
const theme = createTheme({
  palette: {
    primary: {
      main: '#6200EE', // A vibrant purple for primary actions
    },
    secondary: {
      main: '#03DAC6', // A bright teal for secondary elements
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif', // Use the Inter font for a modern look
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8, // Apply rounded corners to all buttons
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12, // Apply more rounded corners to Paper components (cards)
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: 8, // Apply rounded corners to text fields
        },
      },
    },
  },
});

function App() {
  const [tabValue, setTabValue] = useState('');
  const handleTabChange = (_, newValue) => setTabValue(newValue);
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
      setShowCursor(false);
  }, [tabValue]); 

  return (
    // ThemeProvider applies the custom Material-UI theme to the entire app
    <ThemeProvider theme={theme}>
      
      {/* Main container for the app, centered on the screen with a light gray background */}
        <Box
          sx={{
            minHeight: '100vh',
            backgroundColor: '#f3f4f6',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            padding: 1,
          }}
          >
        {/* Paper component acts as the main card for the application, with elevation and rounded corners */}
        <Paper
          elevation={6}
          sx={{
            // padding: 4,
            // pt: 2,
            padding: { xs: 2, sm: 3, md: 4 },
            pt: { xs: 2, sm: 3, md: 2 },
            width: '100%',
            maxWidth: '95vw',
            // minHeight: '90vh',
            boxShadow: 3,
            borderRadius: 3,
          }}
          >
          {/* Application title */}
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              textAlign: 'center',
              color: 'primary.main',
              marginBottom: 1,
              fontWeight: 'bold',
              // height: '45px',
              height: { xs: '35px', sm: '45px' },
              fontSize: { xs: '1.5rem', sm: '2.125rem' },
            }}
          >
            i just need{' '}
            <TypeAnimation
              key={tabValue}
              sequence={[
                tabValue ? `${/json|compar/.test(tabValue) ? 'a' : 'an'} ${tabValue}.` : 'something.',
              ]}
              wrapper="span"
              cursor={showCursor}
              speed={80}
              style={{ display: 'inline-block' }}
            />
          </Typography>
            <Navbar tabValue={tabValue} onTabChange={handleTabChange} />
            {tabValue && tabValue.includes('array') && (
              <ArrayMaker />
            )}
            {tabValue && tabValue.includes('json') && (
              <JsonMaker />
            )}
          {tabValue && tabValue.includes('compar') && (
            <CompareTool />
          )}
          {tabValue && tabValue.includes('xml') && (
            <XmlTool />
          )}
        </Paper>
      </Box>
    </ThemeProvider>
  );
}

export default App;
